/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamSupervisionAbsenceResponse } from './oralExamSupervisionAbsenceResponse';

export type OralExamAggregateTimeSlotStateResponseSupervisionAbsence = OralExamSupervisionAbsenceResponse | null;
